import React, { useMemo } from 'react';
import { useRouter } from 'next/router';
import { Product } from 'interfaces';
import { centsToDollars } from '@/utils/currency';
import useTimeDifference from 'hooks/useTimeDifference';
import ProductType from '@/components/lib/ProductType/ProductType';
import styles from './ProductCard.module.css';
import { parse, stringify } from 'querystring';

interface Props {
  product: Product;
  disablePropagation: boolean;
}

const ProductCard = ({ product, disablePropagation = false }: Props) => {
  const router = useRouter();
  const timeLeft = useTimeDifference(product.auction?.endDate);
  const timeToStart = useTimeDifference(product.auction?.startDate);

  const handleOpenProduct = () => {
    if (disablePropagation) return;

    const basePathParts = router.asPath.split('?');
    const currentPath = basePathParts.shift();
    const currentQuery = basePathParts.shift() || ''

    if (product.isAuction) {
      const queryStr = currentQuery.length ? `?${currentQuery}` : ``;
      router.push(`${currentPath}/auction/${product.id}${queryStr}`);
      return;
    }

    const queryParams = parse(currentQuery);
    const queryStr = stringify({...queryParams, productId: product.id});
    router.push(`${currentPath}/product?${queryStr}`);
  };
  
  const price = useMemo(() => {
    if (!product.isAuction) {
      return centsToDollars(product.price);
    }

    return centsToDollars(product.largestBid);
  }, [product]);

  return (
    <div className={styles.main} onClick={handleOpenProduct}>
      <img src={product.imageUrls[0]} className={styles.image} />
      <div className={styles.info}>
        <span className={styles.title}>{product.title}</span>
        <div className={styles.pricing}>
          <span className={styles.price}>Starting bid: ${ price }</span>
          <div>
            <ProductType timeToStart={timeToStart} timeLeft={timeLeft} isAuction={product.isAuction} bidsAmount={product.bids.length} />
            <span className={styles.shipping}>+ shipping</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
